import { render, staticRenderFns } from "./NumberImage.vue?vue&type=template&id=44cebcdc&scoped=true&"
import script from "./NumberImage.vue?vue&type=script&lang=js&"
export * from "./NumberImage.vue?vue&type=script&lang=js&"
import style0 from "./NumberImage.vue?vue&type=style&index=0&id=44cebcdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cebcdc",
  null
  
)

component.options.__file = "NumberImage.vue"
export default component.exports